import 'tom-select/dist/css/tom-select.bootstrap5.css';
import TomSelect from 'tom-select';
import clear_button from 'tom-select/dist/js/plugins/clear_button';

TomSelect.define('clear_button', clear_button);

function initTomSelect() {
  document.querySelectorAll('[data-behavior="dropdown"]').forEach((item) => {
    if (!item.tomselect) {
      try {
        new TomSelect(item, {
          create: false,
          allowEmptyOption: true,
          openOnFocus: true,
          plugins: ['clear_button']
        });
      } catch (e) {
        console.error("TomSelect init error:", e);
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", initTomSelect);
document.addEventListener("turbo:load", initTomSelect);
document.addEventListener("turbo:render", initTomSelect);

if (document.readyState !== "loading") {
  initTomSelect();
}
